import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/database';
import format from 'date-fns/format'
import _ from 'lodash'
// import startOfWeek from 'date-fns/start_of_week';
// import endOfWeek from 'date-fns/end_of_week';
// import startOfMonth from 'date-fns/start_of_month';
import endOfMonth from 'date-fns/end_of_month';
// import addDays from 'date-fns/add_days';
import addMonths from 'date-fns/add_months';
import moment from 'moment';
export default {
  namespaced: true,
  state: {
    sessions_all: [],
    sessions: [],
    inputSearchSessions: "",
    sessionsSortBy: "class_name",
    sessionResults: 0,
    sessionPage: 1,
    sessionSortField: "",
    sessionSortOrder: "ascending",
    sessionTypingStatus: null,
    university_total: 0,
    size_page: 10,
    topicOpt: [],
    university_total16:0,
    university_graphmonth:[],
    university_graphmonth16:[],
    university:[],
    universityall:[],
    loadingUniversitySessionsTable: true,
    huddleTagData:[],
    huddleTag:{},
    comment:[],
    commentId:'',
    userAll:{},
    member:[],
    organization1level:{},
  },
  mutations: {
    setTopicOption(state:any, result:any){
      state.topicOpt = result
    },
    setAllUniversity(state:any, result:number){
      state.university_total = result
    },
    setAllUniversity16(state:any, result:number){
        state.university_total16 = result
    },
    setGraphMonth(state:any, result:any){
      state.university_graphmonth = result
    },
    setGraphMonth16(state:any, result:any){
        state.university_graphmonth16 = result
    },
    setUniversity(state:any, result:any){
      state.university = result
    },
    setUniversityAll(state:any, result:any){
        state.universityall = result
    },
    setSessionAll(state: any, result: any) {
      state.sessions_all = result
    },
    setSession(state: any, result: any) {
      state.sessions = result
    },
    setInputSearchSessions(state: any, value: any) {
      state.inputSearchSessions = value.keyword
    },
    setSessionResults(state: any, result: any) {
      state.sessionResults = result
    },
    setSessionPage(state: any, result: any) {
      state.sessionPage = result
    },
    setSessionSortField(state: any, result: any) {
      state.sessionSortField = result
    },
    setSessionSortOrder(state: any, result: any) {
      state.sessionSortOrder = result
    },
    setSessionTypingStatus(state: any, status: any) {
      state.sessionTypingStatus = status
    },
    setLoadingSessionsTable(state: any, result: any) {
      state.loadingUniversitySessionsTable = result
    },  
    setHuddleTag(state: any, result: any) {
      state.huddleTagData = result
    },
    setComment(state: any, result: any) {
      state.comment = result
    },
    setCommentID(state: any, result: any) {
      state.commentId = result
    },
    setUserAll(state: any, result: any) {
      state.userAll = result
    },
    setMember(state: any, result: any) {
      state.member = result
    },
    setOrganization1level(state:any, result:any) {
      state.organization1level = result
    },
  },
  actions: {
    async getUniversity({ commit, rootState, state }: any){
      const dateNow = new Date()
      const months: Array<any> = [];
      const months16: Array<any> = [];
      const yearnow = format(dateNow, 'YYYY')
      //const universities_by_month: Array<any> = [];
      for(let x=0; x<6; x++){
          const enddate = format(endOfMonth(addMonths(dateNow, -x)), 'YYYY-MM')
          const year = format(endOfMonth(addMonths(dateNow, -x)), 'YYYY')
          if(yearnow !== year){
              months[enddate] = {
                  month:format(endOfMonth(addMonths(dateNow, -x)), 'MMM ‘YY'),
                  value:0
              }
          }else{
              months[enddate] = { 
                  month:format(endOfMonth(addMonths(dateNow, -x)), 'MMM'),
                  value:0
              }
          }
      }
      for(let x=0; x<16; x++){
          const enddate = format(endOfMonth(addMonths(dateNow, -x)), 'YYYY-MM')
          const year = format(endOfMonth(addMonths(dateNow, -x)), 'YYYY')
          if(yearnow !== year){
              months16[enddate] = {
                  month:format(endOfMonth(addMonths(dateNow, -x)), 'MMM ‘YY'),
                  value:0
              }
          }else{
              months16[enddate] = { 
                  month:format(endOfMonth(addMonths(dateNow, -x)), 'MMM'),
                  value:0
              }
          }
      }
      const topics = (await firebase.database().ref(`/topic_session/`).once('value')).val();
      let topic: Array<any> = [];
      for(const x in topics){
          topics[x].key = rootState.authen.user.company+'-'+x;
          topics[x].follower = 0;
          topic.push(topics[x]);
      }
      const topicsMaster: Array<any> = [];
      await firebase.firestore().collection('classrooms_topic').where("company", "==", rootState.authen.user.company).get().then((query)=>{
          query.forEach((doc) => {
              topicsMaster[doc.id] = doc.data();

              if(doc.data().delete === undefined){
                  if(doc.data().master_id === undefined){
                      const data = doc.data();
                      data.key = doc.id;
                      topic.push(data);
                  }else{
                      const i = _.findIndex(topic, function (el) {
                          return el.key === doc.data().master_id;
                      });
                      topic[i].follower = doc.data().follower;
                  }
              }else{
                  const i = _.findIndex(topic, function (el) {
                      return el.key === doc.data().master_id;
                  });
                  if(i>=0) topic.splice(i, 1);
              }
          });
          
          topic =  _.orderBy(topic, ['name'], ['asc']);
      });
      return new Promise(( res, rej ) => {
          firebase.firestore().collection('classrooms').where("company", "in", [rootState.authen.user.company,rootState.authen.user.company+'-huddles']).orderBy('create_date','desc').get()
          .then(async (querySnapshot)=> {
              const universities: Array<any> = [];
              const universitiesall: Array<any> = [];
              let all_university = 0;
              let all_university16 = 0;
              querySnapshot.forEach((doc) => {
                  const university = doc.data()
                  university.key = doc.id
                  const name = university.create_name.split(' ')
                  university.create_name = `${name[0]} ${name[1].charAt(0)}`
                  university.topic_name = '';
                  // university.class_datetime = format(university.class_datetime, 'MMM D, YYYY [at] H:mm A');
                  if(doc.data().topic_id){
                      university.topic_name = (topicsMaster[doc.data().topic_id] && topicsMaster[doc.data().topic_id].name)?topicsMaster[doc.data().topic_id].name:''
                  }
                  if(universities.length < 4)
                  universities.push(university)
                  universitiesall.push(university)
                  const d = university.create_date.split(' ');
                  const date = d[0].split('-');
                  const enddate = format(new Date(date[0],(date[1]-1),date[2]), 'YYYY-MM')
                  if(months[enddate] !== undefined){
                      months[enddate].value += university.signup.length
                      all_university += university.signup.length
                  }
                  if(months16[enddate] !== undefined){
                      months16[enddate].value += university.signup.length
                  }
                  all_university16 += university.signup.length
              });
              commit('setTopicOption', topic)
              commit('setAllUniversity', all_university16)
              commit('setAllUniversity16', all_university16)
              commit('setGraphMonth', months)
              commit('setGraphMonth16', months16)
              commit('setUniversity', universities)
              commit('setUniversityAll', universitiesall)
              commit("setSession", universitiesall.slice(0, state.size_page));
              commit("setSessionAll", universitiesall);
              commit("setSessionResults", universitiesall.length);
              commit('setLoadingSessionsTable', false)
              res();
          });
      });
    },
    searchSessions({ commit, state, dispatch }: any, data: any) {
      clearTimeout(state.sessionTypingStatus)
      state.sessionTypingStatus = setTimeout(() => {
        commit('setSessionPage', 1)
        if (data.value.length > 0) {
          dispatch('sortSesstions', {
            0: state.sessionSortField,
            1: state.sessionSortOrder,
            3: data.value
          })
        } else if (data.value.length == 0) {
          let sessions: Array<any> = [];
          sessions = state.sessions_all
          commit('setSessionResults', sessions.length)
          commit('setSession', sessions.slice(0, state.size_page))
        }
      }, data.typingTimeout)
    },
    sortSesstions({ commit, state }: any, value: any) {
      // let sessions: Array<any> = [];
      // sessions.push(state.sessions_all)
      // let textSearching = value[3] || state.inputSearchSessions;
      // if (textSearching.length > 0) {
      //   if (sessions.length > 0) {
      //     let re = new RegExp(textSearching, 'gi')
      //     let response = _.filter(sessions[0], (item): any => {
      //       if (item.class_name.match(re)) {
      //         return true
      //       } else if (item.create_name != undefined && item.create_name.match(re)) {
      //         return true
      //       } else if (item.topic_name != undefined && item.topic_name.match(re)) {
      //         return true
      //       }
      //     });
      //     sessions = []
      //     sessions.push(response)
      //   }
      // }

      let field = value[0]
      commit('setSessionSortField', field)
      let order = value[1]
      commit('setSessionSortOrder', order)

      // let newSessions = {}
      // for (let i = 0; i < sessions[0].length; i++) {
      //   newSessions[i] = sessions[0][i]
      //   let time = sessions[0][i].class_datetime
      //   let class_datetime = time.split(" at").join(",")
      //   newSessions[i].timestamp = new Date(class_datetime.substring(0, class_datetime.length - 3)).getTime()
      // }
      // if (field === "signup" || field === "class_price" || field === "class_datetime") {
      //   if (order === "ascending") {
      //     order = 'desc'
      //   } else {
      //     order = 'asc'
      //   }
      // } else {
      //   if (order === "ascending") {
      //     order = 'asc'
      //   } else {
      //     order = 'desc'
      //   }
      // }
      // if (field === "class_datetime" || field === "") {
      //   field = "timestamp"
      // }
      // let _users
      // _users = _.orderBy(newSessions, [field], [order]);
      // commit('setSessionResults', _users.length)
      // commit('setSession', _users.slice(0, state.size_page))
    },
    currentSessionsChange({ commit, state }: any, page: any) {
      // let size = state.size_page
      // let start_row = (page - 1) * size
      // let end_row = ((page - 1) * size) + size
      // let sessions: Array<any> = [];
      // if (state.inputSearchSessions.length > 2) {
      //   let re = new RegExp(state.inputSearchSessions, 'gi')
      //   let response = _.filter(state.sessions_all, (item): any => {
      //     if (item.class_name.match(re)) {
      //       return true
      //     } else if (item.create_name != undefined && item.create_name.match(re)) {
      //       return true
      //     } else if (item.topic_name != undefined && item.topic_name.match(re)) {
      //       return true
      //     }
      //   });
      //   sessions = response
      // } else {
      //   sessions = state.sessions_all
      // }

      commit('setSessionPage', page)
      // commit('setSession', sessions.slice(start_row, end_row))
      // commit('setSession', state.sessions_all)
    },
    async createSession({commit,rootState,dispatch,state}:any,form:any){
      let data = form.form
      commit('setSession', [])
      commit('setLoadingSessionsTable', true)
      let huddles=form.huddles
      let huddle: any[] = [];
      let filter=_.find(
        huddles,
        function (value) {
          return value == "everyone";
        }
      );  
      huddles.map(v=>{
        if(v!='everyone'){
          if(state.huddleTag[v].type=="houses"){
            huddle.push({
              key:state.huddleTag[v].value,
              value:state.huddleTag[v].label,
              selected:true,
              show:true,
              house:true
            })
          }else{
            huddle.push({
              key:state.huddleTag[v].value,
              value:state.huddleTag[v].label,
              selected:true,
              show:true,
              team:true
            })
          }

        }
      })
      const classroom = {
        class_name: data.name,
        class_description: data.description,
        class_datetime: data.dateAndTime,
        class_location: data.location,
        class_limit: data.sessionLimit * 1,
        class_price: (data.price !== undefined && data.price !== '')?data.price * 1:0,
        company: rootState.authen.user.company,
        create_name: `${rootState.authen.user.firstname} ${rootState.authen.user.lastname}`,
        create_user: rootState.authen.user.email,
        // create_user: 'frame.yuranan@gmail.com', /*FIX*/
        minutes: Number(data.duration),
        comment_type: Number(data.commentPermission),
        topic_id: (data.topic) ? data.topic : '',
        sharelink: '',
        signup: [],
        calculate: 'N',
        create_date: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
      }
      if(!filter){
        classroom["huddles"]=huddle
      }
      const ref = firebase.firestore().collection('classrooms').doc();
      const myId = ref.id;
      firebase.firestore().collection('classrooms').doc(myId).set(classroom).then(docRef => {
        dispatch('getUniversity')
      });
    },
    async editSession({commit,rootState,dispatch,state}:any,obj:any){
      let data = obj.form
      commit('setSession', [])
      commit('setLoadingSessionsTable', true)
      let huddles=obj.huddles
      let huddle: any[] = [];
      let filter=_.find(
        huddles,
        function (value) {
          return value == "everyone";
        }
      );  
      huddles.map(v=>{
        if(v!='everyone'){
          if(state.huddleTag[v].type=="houses"){
            huddle.push({
              key:state.huddleTag[v].value,
              value:state.huddleTag[v].label,
              selected:true,
              show:true,
              house:true
            })
          }else{
            huddle.push({
              key:state.huddleTag[v].value,
              value:state.huddleTag[v].label,
              selected:true,
              show:true,
              team:true
            })
          }

        }
      })
      if(obj.id){
        const classroom = {
          class_name: data.name,
          class_description: data.description,
          class_datetime: data.dateAndTime,
          class_location: data.location,
          class_limit: data.sessionLimit * 1,
          minutes: Number(data.duration),
          comment_type: Number(data.commentPermission),
          topic_id: (data.topic) ? data.topic : '',
          update_date: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
        }
        if(!filter){
          classroom["huddles"]=huddle
        }else{
          firebase.firestore().collection('classrooms').doc(obj.id).update({huddles: firebase.firestore.FieldValue.delete()})
        }
        firebase.firestore().collection('classrooms').doc(obj.id).update(classroom).then(() => {
          dispatch('getUniversity')
        })
      }
    },
    async deleteSession({commit,rootState,dispatch,state}:any,value:any){
      commit('setSession', [])
      commit('setLoadingSessionsTable', true)
      const id = value.key;
      delete value.key;
      value.class_id = id;
      value.delete_date = format(new Date(), 'YYYY-MM-DD HH:mm:ss');
      firebase.firestore().collection('classrooms_delete').add(value);
      firebase.firestore().collection('classrooms').doc(id).delete().then(() => {
        dispatch('getUniversity')
      })
    },
    async getHouseAndTeam({commit,rootState,dispatch,state}:any,obj:any){

      let huddleTagData:Array<any> =[
        {
          value: "everyone",
          label: "Everyone",
        },
      ]
      firebase.database().ref('team').orderByChild("company").equalTo(`${rootState.authen.user.company}`).once('value', snapshot => {
          
        snapshot.forEach((arrData):any => {
          const u = arrData.val()
          u.key = arrData.key
          u.value = arrData.val().name
          let data={
            value:  arrData.key ,
            label:  u.name ,
            type:'team'
          }
          if(arrData.key){
            state.huddleTag[arrData.key]=data
          }
          
          huddleTagData.push(data);
          
        });

       
      })
      firebase.database().ref('houses').once('value', (snapshot) => {
        snapshot.forEach((childSnapshot) => {
            var _data = childSnapshot.val();
            _data.key = childSnapshot.key;
            let data={
              value:  childSnapshot.key ,
              label:  _data.name ,
              type:'houses'
            }
            if(childSnapshot.key){
              state.huddleTag[childSnapshot.key]=data
            }
            huddleTagData.push(data);
        })
        huddleTagData = _.sortBy(huddleTagData, ["type", "label"]);
        // console.log("huddleTagData",huddleTagData)
        commit('setHuddleTag', huddleTagData)

      })
    },
    async getComment({commit,rootState,dispatch,state}:any,obj:any){
      let comment:Array<any>=[]
      await firebase.firestore().collection(`classrooms/${obj.id}/comments`).get()
          .then((querySnapshot)=> {
              querySnapshot.forEach((doc) => {
                  let classrooms = doc.data()
                  classrooms.key = doc.id
                  let liked=_.find(classrooms.likeusers, function(o) { return o==rootState.authen.user.email });
                  if(liked){
                    classrooms.liked=true
                  }else{
                    classrooms.liked=false
                  }
                  if(state.userAll[classrooms.user]){
                    
                    classrooms.creatorImageProfile=state.userAll[classrooms.user].profilepic_crop||""
                  }else{
                    classrooms.creatorImageProfile=""
                  }
                  
                  let subComment:Array<any>=[]
                  if(classrooms.comments>0){
                    firebase.firestore().collection(`classrooms/${obj.id}/comments/${doc.id}/comments`).get()
                    .then((_querySnapshot)=> {
                        _querySnapshot.forEach((_doc) => {
                            const _classrooms = _doc.data()
                            _classrooms.key = _doc.id
                            let _liked=_.find(_classrooms.likeusers, function(o) { return o==rootState.authen.user.email });
                            
                            if(state.userAll[_classrooms.user]){
                              _classrooms.creatorImageProfile=state.userAll[_classrooms.user].profilepic_crop||""
                            }else{
                              _classrooms.creatorImageProfile=""
                            }

                            if(_liked){
                              _classrooms.liked=true
                            }else{
                              _classrooms.liked=false
                            }
                            subComment.push(_classrooms)
                            
                    })
                    const _subComment=_.orderBy(subComment, [(obj) => {return new Date(obj.createdate)}], ['asc'])
                    comment.push({...classrooms,subComment:_subComment})
                  })
                    
                }else{
                  
                  comment.push({...classrooms,subComment:[]})
                }
                  
          })
          //console.log("comment",comment)
          commit('setComment',comment)
    })
    },
    async replyComment({commit,rootState,dispatch,state}:any,obj:any){
      let data={
        comments: 0,
        company: rootState.authen.user.company,
        createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
        like: 0,
        likeorder:obj.likeorder,//parseInt('9999'+moment().utc().add(rootState.authen.user.timezone,'hours').format("YYYYMMDDHHmmss")),
        mparent_id:obj.sessionId,
        maprent_id2:obj.comment.key,
        name:rootState.authen.user.firstname+" "+rootState.authen.user.lastname.charAt(0),
        notifications: obj.notifications?obj.notifications:[],
        type: "session",
        user: rootState.authen.user.email,
        value:obj.message}
        await firebase.firestore().collection(`classrooms/${obj.sessionId}/comments/${obj.comment.key}/comments`).add(data).then(()=>{
        });
    },
    async comment({commit,rootState,dispatch,state}:any,obj:any){
      let data={
        comments: 0,
        company: rootState.authen.user.company,
        createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
        like: 0,
        likeorder:obj.likeorder,//parseInt('9999'+moment().utc().add(rootState.authen.user.timezone,'hours').format("YYYYMMDDHHmmss")),
        mparent_id:obj.sessionId,
        name:rootState.authen.user.firstname+" "+rootState.authen.user.lastname.charAt(0),
        notifications:obj.notifications?obj.notifications:[],
        type: "session",
        user: rootState.authen.user.email,
        value:obj.message}
 
        await firebase.firestore().collection(`classrooms/${obj.sessionId}/comments`).add(data).then((docRef)=>{
      
        commit('setCommentID',docRef.id)
      })
    },
    async likeOrUnLike({commit,rootState,dispatch,state}:any,obj:any){
        let like =obj.form.like;
        let likeorder = obj.form.likeorder;

        if(obj.form.liked === true){

          like = like-1;
          const likeordertmp = likeorder.toString().substring(0, 4);
          likeorder = parseInt(String((Number(likeordertmp))+1)+moment().utc().add(rootState.authen.user.timezone,'hours').format("YYYYMMDDHHmmss"));
          var docref =await firebase.firestore().collection(`classrooms/${obj.form.mparent_id}/comments`).doc(obj.form.key);

          docref.update({
            likeusers:firebase.firestore.FieldValue.arrayRemove(rootState.authen.user.email),
            like:firebase.firestore.FieldValue.increment(-1),
            likeorder:likeorder
          });
        }else{

          like = like+1;
          const likeordertmp = likeorder.toString().substring(0, 4);
          likeorder = parseInt(String((Number(likeordertmp))-1)+moment().utc().add(rootState.authen.user.timezone,'hours').format("YYYYMMDDHHmmss"));
          
        const docref =await firebase.firestore().collection(`classrooms/${obj.form.mparent_id}/comments`).doc(obj.form.key);
     
          docref.update({
            likeusers:firebase.firestore.FieldValue.arrayUnion(rootState.authen.user.email),
            like:firebase.firestore.FieldValue.increment(1),
            likeorder:likeorder
          });
        }
   
    },
    async replylikeOrUnlike({commit,rootState,dispatch,state}:any,obj:any){
        let like =obj.form.like;
        let likeorder = obj.form.likeorder;

        if(obj.form.liked === true){
          like = like-1;
          const likeordertmp = likeorder.toString().substring(0, 4);
          likeorder = parseInt(String((Number(likeordertmp))+1)+moment().utc().add(rootState.authen.user.timezone,'hours').format("YYYYMMDDHHmmss"));
          var docref =await firebase.firestore().collection(`classrooms/${obj.form.mparent_id}/comments/${obj.form.maprent_id2}/comments`).doc(obj.form.key);

          docref.update({
            likeusers:firebase.firestore.FieldValue.arrayRemove(rootState.authen.user.email),
            like:firebase.firestore.FieldValue.increment(-1),
            likeorder:likeorder
          });
        }else{

          like = like+1;
          const likeordertmp = likeorder.toString().substring(0, 4);
          likeorder = parseInt(String((Number(likeordertmp))-1)+moment().utc().add(rootState.authen.user.timezone,'hours').format("YYYYMMDDHHmmss"));
        const docref =await firebase.firestore().collection(`classrooms/${obj.form.mparent_id}/comments/${obj.form.maprent_id2}/comments`).doc(obj.form.key);
          docref.update({
            likeusers:firebase.firestore.FieldValue.arrayUnion(rootState.authen.user.email),
            like:firebase.firestore.FieldValue.increment(1),
            likeorder:likeorder
          });
        }
   
    },
    getUser({commit,rootState,dispatch,state}:any,obj:any){
      let userAll={}
      let member:Array<any>=[]
      for (const doc in rootState.main.allUser){
        let data=rootState.main.allUser[doc]
        if(data.email){
          userAll[data.email]=data
         
        }
        data.fullname=data.firstname+" "+data.lastname
        data.name=data.firstname+" "+data.lastname
        data.id=doc
        member.push(data)

      }
      commit('setMember',member)
      commit('setUserAll',userAll)
      // firebase.database().ref(`users`).orderByChild("company").equalTo(rootState.authen.user.company).once('value', snapshot => {
      //   snapshot.forEach((doc):any => {
      //       let data=doc.val()
      //       if(data.email){
      //         userAll[data.email]=data
             
      //       }
      //       data.fullname=data.firstname+" "+data.lastname
      //       data.name=data.firstname+" "+data.lastname
      //       data.id=doc.key
      //       member.push(data)
      //   });
      //   //console.log("member",member)
      //   commit('setMember',member)
      //   commit('setUserAll',userAll)
      // })
    },  
  },
  getters: {
    sessions: (state) => {
      let sessions = state.sessions_all;
      let newSessions = sessions.map((session, index) => {
        let time = session.class_datetime;
        let class_datetime = time.split(" at").join(",");
        return {
          ...session,
          timestamp: new Date(class_datetime.substring(0, class_datetime.length - 3)).getTime(),
          commentsall: session.commentsall || 0
        };
      });
      let field = state.sessionSortField;
      let order = state.sessionSortOrder === "ascending" ? "desc" : "asc";
      if (field === "signup" || field === "class_price" || field === "class_datetime") {
        order = state.sessionSortOrder === "ascending" ? "desc" : "asc";
      }
      if(field === ""){
        field = "create_date"
      }
      let newSessionsSorted:any = _.orderBy(newSessions, [field], [order]);

      let size = state.size_page;
      let page = state.sessionPage;
      let start_row = (page - 1) * size;
      let end_row = ((page - 1) * size) + size;
      let sessionsPageShowing: Array<any> = [];

      if (state.inputSearchSessions.length > 2) {
        let re = new RegExp(state.inputSearchSessions, 'gi');

        let response:any = _.filter(newSessionsSorted, (item): any => {
          if (item && item.class_name && item.class_name.match(re)) {
            return true;
          } else if (item && item.create_name && item.create_name.match(re)) {
            return true;
          } else if (item && item.topic_name && item.topic_name.match(re)) {
            return true;
          }
        });
        sessionsPageShowing = response;
      } else {
        sessionsPageShowing = newSessionsSorted
      }
      return sessionsPageShowing.slice(start_row, end_row) || []
    },
    sessions_all: ({ sessions_all }) => {
      return sessions_all
    },
    inputSearchSessions: ({ inputSearchSessions }) => {
      return inputSearchSessions
    },
    sessionResults: ({ sessionResults }) => {
      return sessionResults
    },
    topicOpt: ({topicOpt}) => {
      return topicOpt
    },
    university: ({university}) => {
        return university
    },
    universityall: ({universityall}) => {
        return universityall
    },
    university_graphmonth: ({university_graphmonth}) => {
        return university_graphmonth
    },
    university_graphmonth16: ({university_graphmonth16}) => {
        return university_graphmonth16
    },
    university_total: ({university_total}) => {
        return university_total
    },
    university_total16: ({university_total16}) => {
        return university_total16
    },
    loadingUniversitySessionsTable: ({loadingUniversitySessionsTable}) => {
      return loadingUniversitySessionsTable
    },
    huddleTagData:({ huddleTagData }) => {
      return huddleTagData
    },
    comment:({ comment }) => {
      comment = _.sortBy(comment, function(dateObj) {
        return new Date(dateObj.createdate);
      });
      return comment
    },
    commentId:({ commentId }) => {
      return commentId
    },
    userAll:({ userAll }) => {
      return userAll
    },
    member:({ member }) => {
      return member
    },
    organization1level:(state:any) => {
      return state.organization1level
  },
  }
}